import { ModelContainer, GlobalErrorMessage, connected } from 'shared'
import { Model } from 'api'
import { PolymorphicModal } from '.'

export default class TopLevelPage extends Component {
  componentDidMount() {
    this.syncBase()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.base != this.props.base)
      this.syncBase()
  }

  syncBase() {
    App.state.setObject({ base: this.props.base })
  }

  render() {
    let { className, modelId, children, fullWidth } = this.props
    if (User.current && User.current.mustChangePassword)
      App.go('change-password')

    return (
      <div className={classNames(className, { container: !fullWidth })}>
        {children}
        {this.renderModal()}
        <GlobalErrorMessage />
      </div>
    )
  }

  renderModal() {
    let { modelId, base, returnUrl, ModalClass = PolymorphicModal } = this.props
    let modalReturnUrl = returnUrl || base

    let activeModalType = application.state.getObject('activeModalType')
    if (activeModalType) return <ModalClass model={activeModalType} returnUrl={modalReturnUrl} />

    if (modelId == null) return null
    if (modelId == 'chat') return <ModalClass model='chat' returnUrl={modalReturnUrl} />
    if (modelId == 'guest-signup') return <ModalClass model='guest-signup' returnUrl={modalReturnUrl} />

    let pureModelId = Model.extractPureModelId(modelId)
    let subroute = Model.extractSubroute(modelId)

    return <ModelContainer modelId={pureModelId}>
      { model => <ModalClass model={model} returnUrl={modalReturnUrl} subroute={subroute} /> }
    </ModelContainer>
  }
}
